import React, { useState } from "react";
import {
    Row,
    Col,
    Modal, ModalHeader, ModalBody
} from "reactstrap";
import { toast } from "react-toastify";
import { SuccessOk } from "configs/statusCode";
import SalesRepsService from "services/Admin/SalesRepsService";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';

function ModalForm({modal, toggle,setShouldGetData ,setShowSuccessModal}) {
    const [selectedPermission, setSelectedPermission] = useState(null)
    const [loading, setLoading] = useState(false)

    const handleValidSubmit = (e, values) => {
        if (!selectedPermission) {
            toast.error("please enter the permission of the admin")
        } else {
            setLoading(true)
            const data = {
                email: values.email,
                permission: selectedPermission
            }
            new SalesRepsService().inviteSalesRep(data).then(response => {
                if (response && response.status === SuccessOk) {
                    setShouldGetData(true)
                     toggle()
                    setShowSuccessModal(true)
                }
            })
        }
    }
    return (
        <Modal isOpen={modal} toggle={toggle} className="scrollbar-container mt-5">
            <ModalHeader className="border-0" toggle={toggle}>
                Invite Sales Representative
                <p className="textMuted  font-weight-normal pt-2 font-size-13">Invite sales rep to manage the appointments</p>
            </ModalHeader>
            <ModalBody className="pt-0">
                <AvForm
                    className='form-horizontal formWithLabel'
                    onValidSubmit={(e, v) => {
                        handleValidSubmit(e, v);
                    }}>
                    <Row>
                        <Col md={12}>
                            <AvField
                                className="mb-3 font-size-14"
                                name="email"
                                label="Email Address"
                                bsSize="lg"
                                required
                                type="email"
                                placeholder="Email Address"
                            />
                            <div className="d-sm-flex mb-2 editSelectLabel radio-container">
                                <label>Permissions</label>
                                <AvRadioGroup name="permissions"  required onChange={(e) => { setSelectedPermission(e.target.value); }} >
                                    <AvRadio label="Deals" value="Deals" />
                                    <AvRadio label="Leads" value="Leads" />
                                </AvRadioGroup>
                            </div>
                        </Col>
                    </Row>
                    <div className="px-0 border-0 pt-2">
                        <button 
                        type='submit'
                         className='btn btn-success w-100'
                         disabled={loading ? true : false}
                         >
                            Send an invitation
                        </button>
                    </div>
                </AvForm>
            </ModalBody>
        </Modal>
    );
}

export default ModalForm;
